import React from "react";
import { createFromIconfontCN } from '@ant-design/icons';

const PRIMARY_ICONFONT_SCRIPT_URL = '//at.alicdn.com/t/c/font_5037819_a72xy7yjoj.js';
const EXTENDED_ICONFONT_SCRIPT_URL = '//at.alicdn.com/t/c/font_5037819_skpmc7ng9s.js';

const IconFont = createFromIconfontCN({
  // 数组前面的资源优先级更高：保留现有图标版本，新资源补充 icon-xmind 等新增 symbol。
  scriptUrl: [PRIMARY_ICONFONT_SCRIPT_URL, EXTENDED_ICONFONT_SCRIPT_URL],
});

export interface XcIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** 图标名称 */
  name: string;
  /** 图标大小 */
  size?: number | string;
  /** 图标颜色 */
  color?: string;
}

type DocgenInfo = {
  displayName: string;
  description: string;
  props: Record<string, {
    name: string;
    required: boolean;
    description: string;
    type: { name: string; raw: string };
    defaultValue?: { value: string };
  }>;
};

type ComponentWithDocgen = React.FC<XcIconProps> & { __docgenInfo?: DocgenInfo };

/** 自定义图标组件，基于 iconfont */
export const XcIcon: React.FC<XcIconProps> = ({ 
  name, 
  size, 
  color, 
  style,
  ...props 
}) => {
  const iconStyle = {
    fontSize: size,
    color,
    ...style,
  };

  return (
    <IconFont 
      {...props} 
      type={name} 
      style={iconStyle}
    />
  );
};

// 手动添加 docgen 信息
(XcIcon as ComponentWithDocgen).__docgenInfo = {
  displayName: "XcIcon",
  description: "自定义图标组件，基于 iconfont",
  props: {
    name: {
      name: "name",
      required: true,
      description: "图标名称",
      type: { name: "string", raw: "string" }
    },
    size: {
      name: "size",
      required: false,
      description: "图标大小",
      type: { name: "number | string", raw: "number | string" }
    },
    color: {
      name: "color",
      required: false,
      description: "图标颜色",
      type: { name: "string", raw: "string" }
    },
    className: {
      name: "className",
      required: false,
      description: "自定义类名",
      type: { name: "string", raw: "string" }
    },
    style: {
      name: "style",
      required: false,
      description: "自定义样式",
      type: { name: "CSSProperties", raw: "React.CSSProperties" }
    }
  }
};
